module.exports = __webpack_public_path__ + "images/emoji/sweat_drops.c5171b261e45305a2812.png";